import IpubTooltip from './src/main'

/* istanbul ignore next */
IpubTooltip.install = function(Vue) {
  Vue.component(IpubTooltip.name, IpubTooltip)
}

export default IpubTooltip
